import React from 'react';
import { withTranslation, WithTranslation, Trans } from '@wix/wix-i18n-config';
import s from './FAQ.scss';
import translations from '../../assets/locales/messages_en.json';
import { openNewTab } from '../../services/window-utils';
import { getWixSupportUrl } from '../../services/urls';

class FAQ extends React.Component<WithTranslation> {
  PREFIX_TITLE = 'faq.title.';
  PREFIX_DESCRIPTION = 'faq.description.';

  faqKeys = () => {
    return Object.keys(translations)
      .filter((str) => str.startsWith(this.PREFIX_TITLE))
      .map((str) => str.substring(this.PREFIX_TITLE.length));
  };

  faqDescriptionValues = (id: string) => {
    const keys = Object.keys(translations);
    const values = Object.values(translations);
    const indexOfFAQId = keys.indexOf(`${this.PREFIX_DESCRIPTION}${id}`);
    return values[indexOfFAQId];
  };

  onWinHelpCenterClicked = () => {
    openNewTab(getWixSupportUrl());
  };

  renderFAQ = (id: string) => {
    const { t } = this.props;
    const dataHook = `faq-${id}-linkButton`;
    const descriptionValue = this.faqDescriptionValues(id);
    const isDescriptionIncludeTrans =
      descriptionValue.includes('<1>') && descriptionValue.includes('</1>');
    if (!isDescriptionIncludeTrans) {
      return t(`${this.PREFIX_DESCRIPTION}${id}`);
    }

    return (
      <Trans i18nKey={`${this.PREFIX_DESCRIPTION}${id}`}>
        <>Visit the </>
        <button
          className={s.linkButton}
          data-hook={dataHook}
          onClick={this.onWinHelpCenterClicked}
          tabIndex={0}
          aria-pressed="false"
          aria-label="Wix Help Center"
        >
          Wix Help Center
        </button>
        <> for more information.</>
      </Trans>
    );
  };

  renderFAQColumn = (number: number) => {
    const { t } = this.props;
    const faqKeysArray = this.faqKeys();

    return (
      <div className={s.faqColumn}>
        {faqKeysArray.map(
          (id, index) =>
            index >= 3 * number &&
            index < 3 * number + 3 && (
              <div key={id} className={s.faq} data-hook="faq-faq">
                <div className={s.faqTextBox} data-hook="faq-faqTextBox">
                  <div className={s.faqTitle} data-hook={`faq-faqTitle-${id}`}>
                    {t(`${this.PREFIX_TITLE}${id}`)}
                  </div>
                  <div
                    className={s.faqDescription}
                    data-hook={`faq-faqDescription-${id}`}
                  >
                    {this.renderFAQ(id)}
                  </div>
                </div>
              </div>
            ),
        )}
      </div>
    );
  };

  render() {
    const { t } = this.props;

    return (
      <div className={s.strip} data-hook="faq-strip">
        <div className={s.root} data-hook="faqList">
          <div className={s.title} data-hook="faq-title">
            {t('faq.title')}
          </div>
          <div className={s.listOfFaq} data-hook="faq-listOfFaq">
            {this.renderFAQColumn(0)}
            {this.renderFAQColumn(1)}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(FAQ);
